<div class="layoutBlock">
    <div class="columnFull">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.ibanSelected"
                    [(ngModel)]="accountSelected" [dropdown]="true" [suggestions]="accountSuggestions"
                    (completeMethod)="filterAccountsToShow($event)" field="accountIban"
                    (onSelect)="onSelectIban($event)" (ngModelChange)="onModelChange($event)">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.bicSelected"
                    [(ngModel)]="bicSelected" [dropdown]="true" [suggestions]="bicSuggestions"
                    (completeMethod)="filterBicsToShow($event)" (onSelect)="onSelectBic($event)">
                </p-autoComplete>
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.validFrom' | hisUi}}">
                <span #content class="plamContentText">{{accountSelected?.validFromDate| hisDate}}</span>
            </his-plam>

            <his-plam
                label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.validTo' | hisUi}}">
                <span #content class="plamContentText">{{accountSelected?.validToDate | hisDate}}</span>
            </his-plam>

        </p-panel>
    </div>

    <div class="columnFull">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.changes' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.applyChanges"
                    [(ngModel)]="bankDetails.changeBankDetails" (ngModelChange)="resetBankDetailsChanges()"
                    type="checkbox" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.changeAccountNewIban"
                    class="inputWidth100" [(ngModel)]="bankDetails.changeAccountNewIban"
                    [disabled]="bankDetails.changeBankDetails !== true" (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails.changeAccountNewBic"
                    class="inputWidth100" [(ngModel)]="bankDetails.changeAccountNewBic"
                    [disabled]="bankDetails.changeBankDetails !== true" (ngModelChange)="onModelChange($event)" />
            </his-plam>

        </p-panel>
    </div>
</div>